import { render, staticRenderFns } from "./SubFive.vue?vue&type=template&id=75a075ff&"
import script from "./SubFive.vue?vue&type=script&lang=js&"
export * from "./SubFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports